module.exports={
	"Scope": "DocumentApprovalWorkflow-List",
	"CoreEntity": "DocumentApprovalWorkflow",
	"TitleTemplate": "Document Approval Workflows",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Transition Name",
			"Hash": "DocWfListName",
			"PictDashboard": {}
		},
		"FromStatus":
		{
			"Name": "From Status",
			"Hash": "DocWfListFromStatus",
			"PictDashboard": {}
		},
		"ToStatus":
		{
			"Name": "To Status",
			"Hash": "DocWfListToStatus",
			"PictDashboard": {}
		},
		"IDProject":
		{
			"Name": "Project ID",
			"Hash": "DocWfListIDProject",
			"PictDashboard": {}
		}
	}
}
